import { AxiosError, AxiosResponse } from 'axios';
import { ERROR_MESSAGES } from '@lon/shared/constants';
import { User } from '@lon/shared/types';

export type SuccessResponse = AxiosResponse<{
  user: User;
  ttl: number;
}>;

export type ErrorResponse = AxiosError<{
  error: { code: keyof typeof ERROR_MESSAGES };
}>;

export interface FormValues {
  username: string;
  password: string;
  mfaCode?: string;
  district?: string;
}

export enum LoginState {
  'Password',
  'MFA',
}

export type OnSubmitProps = FormValues & {
  district: string;
  isMFA: boolean;
  onSuccess(user: User): void;
  setLoginState(state: LoginState): void;
};
